import { AVERAGE_INCOME, FLOW_POINTS } from '../../../../shared/constants';
import { DataLayersActions } from './dataLayers.actions';

const initialState = {
  dataLayers: {
    userOptions: {
      isOpen: false,
    },
    standardMap: {
      name: 'standardMap',
      id: 'standardMap',
      selected: true,
    },
    satellite: {
      name: 'satellite',
      id: 'satellite',
      selected: false,
    },
    neighborhood: {
      name: 'neighborhood',
      id: 'neighborhood',
      selected: false,
    },
    zoning: {
      name: 'zoning',
      id: 'zoning',
      selected: false,
    },
    valueZoning: {
      name: 'valueZoning',
      id: 'valueZoning',
      selected: false,
    },
    censusSectors: {
      name: 'censusSectors',
      id: 'censusSectors',
      selected: false,
    },
    averageIncome: {
      name: 'averageIncome',
      id: 'averageIncome',
      selected: false,
      options: AVERAGE_INCOME,
    },
    flowPoints: {
      name: 'flowPoints',
      id: 'flowPoints',
      selected: false,
      options: FLOW_POINTS,
    },
    demographicDensity: {
      name: 'demographicDensity',
      id: 'demographicDensity',
      selected: false,
    },
    verticalization: {
      name: 'verticalization',
      id: 'verticalization',
      selected: false,
    },
  },
  polygons: {
    neighborhood: [],
    zoning: [],
    valueZoning: [],
    socioEconomicDemographic: [],
    averageIncome: [],
  },
  isPressed: false,
};

// TODO:
// TRAZER TODOS OS STATES RELATIVOS A CAMADA DE DADOS PARA CÁ
// GRADATIVAMENTE, VAMOS IMPLEMENTAR O CLEAN CODE

interface DataLayersReducer {
  type: string;
  payload: any;
}

export default function dataLayersReducer(
  state = initialState,
  { type, payload }: DataLayersReducer
) {
  switch (type) {
    case DataLayersActions.SET_IS_PRESSED:
      return {
        ...state,
        isPressed: payload,
      };
    case DataLayersActions.UPDATE_DATA_LAYERS:
      return {
        ...state,
        dataLayers: {
          ...state.dataLayers,
          [payload.name]: {
            ...state.dataLayers[payload.name as keyof typeof state.dataLayers],
            selected: payload.value,
          },
        },
      };
    case DataLayersActions.RESET_DATA_LAYERS:
      return {
        ...state,
        dataLayers: initialState.dataLayers,
      };
    case DataLayersActions.REMOVE_POLYGONS:
      state.polygons[payload as keyof typeof state.polygons]?.forEach(
        (polygon: google.maps.Polygon) => polygon.setMap(null)
      );
      return { ...state, polygons: { ...state.polygons, [payload]: [] } };
    case DataLayersActions.SET_POLYGONS:
      return {
        ...state,
        polygons: { ...state.polygons, [payload.name]: payload.value },
      };
    case DataLayersActions.ADD_POLYGON:
      return {
        ...state,
        polygons: {
          ...state.polygons,
          [payload.name]: [
            ...state.polygons[payload.name as keyof typeof state.polygons],
            payload.value,
          ],
        },
      };
    case DataLayersActions.OPEN_CLOSE_USER_OPTIONS:
      return {
        ...state,
        dataLayers: {
          ...state.dataLayers,
          userOptions: {
            ...state.dataLayers.userOptions,
            isOpen: !state.dataLayers.userOptions.isOpen,
          },
        },
      };
    case DataLayersActions.UPDATE_OPTIONS:
      return {
        ...state,
        dataLayers: {
          ...state.dataLayers,
          [payload.name]: {
            ...state.dataLayers[payload.name as keyof typeof state.dataLayers],
            options: payload.options,
          },
        },
      };
    case DataLayersActions.UPDATE_OPTION_MARKERS: {
      return {
        ...state,
        dataLayers: {
          ...state.dataLayers,
          flowPoints: {
            ...state.dataLayers.flowPoints,
            options: state.dataLayers.flowPoints.options.map((flowpoint) => {
              if (flowpoint.id === payload.name) {
                return {
                  ...flowpoint,
                  markers: payload.markers,
                  checked: true,
                };
              }
              return flowpoint;
            }),
          },
        },
      };
    }
    default:
      return state;
  }
}
